"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        padding: 10,
        border: `1px solid ${theme.grey3}`,
        '&[data-has-error=true]': {
            border: `1px solid ${theme.error}`
        }
    },
    fieldWrapper: {
        marginBottom: 20,
        padding: 14,
        backgroundColor: theme.grey9,
        border: `1px solid ${theme.grey6}`,
        borderRadius: 5
    },
    styledDiv: {
        fontSize: 14,
        marginBottom: 10
    },
    styledBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    }
});
//# sourceMappingURL=arrayField.style.js.map